import React from 'react';
import { useSelector } from 'react-redux';
import Select from './Select.js';
const CostCeilingDefaultSelect = (props) => {
    const { enabled, inheritLabel, disabled, onChange } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Select, { value: enabled === undefined ? 'inherit' : enabled ? 'enabled' : 'disabled', onChange: (e) => onChange(e.target.value === 'inherit'
            ? undefined
            : e.target.value === 'enabled'), disabled: disabled },
        React.createElement("option", { value: "inherit" }, inheritLabel),
        React.createElement("option", { value: "enabled" }, lang.costCeiling.enabled),
        React.createElement("option", { value: "disabled" }, lang.costCeiling.disabled)));
};
export default CostCeilingDefaultSelect;
//# sourceMappingURL=CostCeilingDefaultSelect.js.map